import { gql } from "@apollo/client";

export const addUserOnboardingVideos = gql`
  mutation addUserOnboardingVideos($record: CreateOneUserOnboardingVideosInput!) {
    UserOnboardingVideo_CreateOne(record: $record) {
      record {
        _id
      }
    }
  }
`;

export const editUserOnboardingVideos = gql`
  mutation editUserOnboardingVideos($_id: MongoID!, ,$record: UpdateByIdUserOnboardingVideosInput!) {
    UserOnboardingVideo_UpdateById(_id :$_id, record: $record) {
      record {
        _id
      }
    }
  }
`;
